export const getters = {
  sku: (state: any) => state.sku
}
